/**
 * Payment Form Component
 * Handles credit card and PayPal payment processing
 */

import { usePaymentForm } from './usePaymentForm'
import type { PaymentFormProps } from './paymentFormTypes'
import { PaymentFormGuardPanel } from './PaymentFormGuardPanel'
import { PaymentFormMethodSelector } from './PaymentFormMethodSelector'
import { PaymentCreditCardForm } from './PaymentCreditCardForm'
import { PaymentPayPalPanel } from './PaymentPayPalPanel'
import { PaymentFormNameModal } from './PaymentFormNameModal'

export type { PaymentFormProps } from './paymentFormTypes'

export function PaymentForm(props: PaymentFormProps) {
  const form = usePaymentForm(props)

  if (form.guard) {
    return <PaymentFormGuardPanel guard={form.guard} />
  }

  const paymentConfig = form.paymentConfig
  if (!paymentConfig) {
    return <PaymentFormGuardPanel guard="loading_config" />
  }

  return (
    <div className="bg-white rounded-xl shadow-md border border-gray-200 p-4 sm:p-6 md:p-8">
      <div className="flex flex-col md:flex-row gap-6">
        <PaymentFormMethodSelector
          paymentConfig={paymentConfig}
          paymentMethod={form.paymentMethod}
          onSelect={form.setPaymentMethod}
        />

        <div className="w-full md:w-3/4">
          {form.paymentMethod === 'CARDCONNECT' && (
            <PaymentCreditCardForm form={form} isLoading={props.isLoading ?? false} />
          )}
          {form.paymentMethod === 'Paypal' && (
            <PaymentPayPalPanel
              form={form}
              onPayPalPaymentSuccess={props.onPayPalPaymentSuccess}
              onPayPalPaymentError={props.onPayPalPaymentError}
              isLoading={props.isLoading}
            />
          )}
        </div>
      </div>

      <PaymentFormNameModal
        isOpen={form.showNameInfoModal}
        onClose={() => form.setShowNameInfoModal(false)}
      />

      {/* <PaymentTrustwaveSeal /> */}
    </div>
  )
}
